// extracted by mini-css-extract-plugin
export default {"tableWrapper":"Table_tableWrapper__IsFnv","table":"Table_table__QBn3w"};